import { translate } from 'components/Translation';

export const documentTypeToString = (documentType: types.organizations.documentType) => {
	switch (documentType) {
		case 'EMBASSIES_ID':
			return translate('embassy.id');
		case 'CUST_NO':
			return translate('government.id');
		default:
			return translate('cr.number');
	}
};
